import React from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';

import NotFound from 'pages/NotFound';
import Planner from 'pages/Planner';
import Sessions from 'pages/Sessions';
import ToolBuildGroup from 'pages/Tools/BuildGroup';


import Loader from 'components/Loader';
import Pages from 'configs/pages';

import useConfig from 'hooks/useConfig';


function App() {
	const {loaded} = useConfig({
		init: true
	});

	if (!loaded) {
		return (
			<Loader />
		);
	}

	return (
		<Router>
			<Switch>
				<Route key={'page2'} exact={true} path={Pages.planner.url}>
					<Planner />
				</Route>
				<Route key={'page3'} exact={true} path={Pages.plannerWithSession.url}>
					<Planner />
				</Route>
				<Route key={'page4'} exact={true} path={Pages.sessions.url}>
					<Sessions />
				</Route>
				<Route key={'page5'} exact={true} path={Pages.toolBuildGroup.url}>
					<ToolBuildGroup />
				</Route>
				<Route component={NotFound} />
			</Switch>
		</Router>
	);
}

export default App;
